export { default } from './AvailableTilesTable';
